import { Base, TabGroup, TabList, Tab } from '@itsrever/design-system'
import { Link, useLocation } from 'react-router'

export interface TabProps {
  link: string
  copy: string
  // Who the tab is for, when not everyone sees it.
  badge?: string
}

interface Props {
  selectedIndex: number
  tabs: TabProps[]
}

export const NavigationTabs: React.FC<Props> = ({ selectedIndex, tabs }) => {
  const location = useLocation()
  return (
    // Sticky because the page scrolls in the layout's page frame, above the per-page one: the
    // tabs are a sibling of the content there, so without this they scroll out of reach.
    <nav className="sticky top-0 z-20 w-full bg-white">
      <TabGroup selectedIndex={selectedIndex}>
        <TabList fullWidth>
          {tabs.map((tab, index) => (
            <Link key={index} to={`${tab.link}${location.search}`}>
              <Tab>
                {tab.badge ? (
                  <p className="flex items-center gap-2">
                    {tab.copy}
                    <Base.Badge tone="info">{tab.badge}</Base.Badge>
                  </p>
                ) : (
                  <p>{tab.copy}</p>
                )}
              </Tab>
            </Link>
          ))}
        </TabList>
      </TabGroup>
    </nav>
  )
}
